module.exports = __webpack_public_path__ + "img/light.b2ba208e.png";